import { useState } from "react";
import '../HarmonicCycles.scss'
import { CycleOfSecondsMap } from "./CycleOfSecondsMap";
import { CycleOfSecondsPair } from "./CycleOfSecondsPair";
import { DotNav } from "../../../../Comps/DotNav/DotNav";
import { OutlineBox } from "../../../../Comps/OutlineBox/OutlineBox";
import { ChapterConfig } from "../../../ChapterConfig";
import { ClearHelpers } from "../../../Helpers/ClearHelpers/ClearHelpers";
import { ChapterNavItem, ChapterNav } from "../../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../../ChapterNav/ChapterRoutes";

export function CycleOfSeconds(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>}
    ]
    return  <div className={'cycle-of-seconds'}>
                <h1>The Cycle of Seconds in the HexMap</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const width:number = 900
    const [screenIndex, setScreenIndex] = useState(0)
    const onNavClick = (navIndex:number) => {
        setScreenIndex(navIndex)
    }
    const getHexMaps = () => {return [
        <CycleOfSecondsMap/>,
        <CycleOfSecondsPair/>
    ]}
    const hexMaps = getHexMaps()
    return(
        <OutlineBox title={'The Cycle of Seconds as an Extended Diagonal Row'} width={width}>
            <div className={'harmonic-cycle'}>
                <div className={'harmonic-cycle-page-container'}>
                    {hexMaps[screenIndex]}
                </div>
            </div>
            <DotNav length={hexMaps.length} selectedIndex={screenIndex} onClick={onNavClick}/>
        </OutlineBox>
    )
}
